import { useQueryClient } from '@tanstack/react-query';
import { ErrorInfo } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { UnexpectedErrorFallback } from '../../components/ErrorFallback/UnexpectedErrorFallback';
import { useLogger } from '../../context/useLogger';
import { logError } from '../../utils/logHelper';

// Niveau 1 : erreur catastrophique, rien ne marche — clear all + reload
export function RootErrorBoundary({ children }: Readonly<{ children: React.ReactNode }>) {
  const logger = useLogger();
  const queryClient = useQueryClient();

  return (
    <ErrorBoundary
      FallbackComponent={UnexpectedErrorFallback}
      onError={(error: unknown, info: ErrorInfo) => {
        const fallBackError = error instanceof Error ? error : new Error('Unknown error');
        logError(logger, fallBackError, info);
      }}
      onReset={() => {
        queryClient.clear();
        globalThis.location.reload();
      }}
    >
      {children}
    </ErrorBoundary>
  );
}
